import React, { useEffect, useState } from "react";
import { InvokeAPI } from "../../apis/API";
import { getInternalMgmtBase, getQuestionMgmtBase } from "../../config/apiBase";
import { Alert, Box, Toolbar, Button, Stack, TextField, Divider, Snackbar } from "@mui/material";
import AsyncButton from "../../components/common/AsyncButton";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';


const QAReview = () => {
    const [state, setState] = useState({ open: false, severity: "", message: "" })
    const handleClose = () => {
        setState({ ...state, open: false });
    };
    const [dialog, setDialog] = useState({ open: false, user: false, group: false, question: false, id: "", button: "", content: "" })

    const handleDialogClose = () => {
        setDialog({ open: false })
    }

    const handleDialogContinue = async () => { }
    const [reviewData, setReviewData] = useState({})
    const getAllQuestions = async () => {
        //do something
        const info = await InvokeAPI(`${getInternalMgmtBase()}/v1/qareview`,
            { "TimeMilli": 0 },
            'POST',
            {},
            false)
        return info.response
    }

    useEffect(() => {
        getAllQuestions().then(data => setReviewData(data));
    }, []);

    const handleNext = async (e) => {
        //e.preventDefault();
        InvokeAPI(`${getInternalMgmtBase()}/v1/qareview`,
            { "TimeMilli": reviewData.TimeMilli },
            'POST',
            {},
            false).then(data => setReviewData(data.response))
        window.scrollTo({ top: 0 })
    }

    const handleQuestionCange = (index, value) => {
        var newData = reviewData
        newData.QAList[index].Question.Qtext = value
        //console.log(newData)
        setReviewData(newData)
    }

    const handleOptionChange = (qIndex, oIndex, value) => {
        var newData = { ...reviewData }
        newData.QAList[qIndex].Options[oIndex].Otext = value
        setReviewData(newData)
    }

    const handleAnswerChange = (index, value) => {
        var newData = { ...reviewData }
        newData.QAList[index].Answer.Atext = value
        setReviewData(newData)
    }

    const handleUpdateQuestion = async (index) => {
        //API call to update question from the index
        console.log(reviewData.QAList[index].Question)
        const question = reviewData.QAList[index].Question
        const response = await InvokeAPI(`${getQuestionMgmtBase()}/v1/question/update`,
            {
                "ID": question.ID,
                "Qtype": question.Qtype,
                "Qtext": question.Qtext,
                "Qlevel": question.Qlevel,
                "Qsubject": question.Qsubject,
                "Qcategory": question.Qcategory,
                "Qclass": question.Qclass,
                "MetaID": question.MetaID,
            },
            'POST',
            {},
            false)
        if (response && !response.internal) {
            setState({ open: true, severity: "success", message: "Question updated successfully" })
        } else {
            setState({ open: true, severity: "error", message: "Failed to update question" })
        }
    }

    const handleUpdateOption = async (qIndex, oIndex) => {
        const option = reviewData.QAList[qIndex].Options[oIndex]
        const question = reviewData.QAList[qIndex].Question
        const response = await InvokeAPI(`${getQuestionMgmtBase()}/v1/option/update`,
            {
                "ID": option.ID,
                "Otype": option.Otype || "text",
                "Otext": option.Otext,
                "QID": question.ID,
            },
            'POST',
            {},
            false)
        if (response && !response.internal) {
            setState({ open: true, severity: "success", message: "Option updated successfully" })
        } else {
            setState({ open: true, severity: "error", message: "Failed to update option" })
        }
    }

    const handleUpdateAnswer = async (index) => {
        const answer = reviewData.QAList[index].Answer
        const question = reviewData.QAList[index].Question
        const response = await InvokeAPI(`${getQuestionMgmtBase()}/v1/answer/update`,
            {
                "ID": answer.ID,
                "Atype": answer.Atype || "text",
                "Atext": answer.Atext,
                "QID": question.ID,
            },
            'POST',
            {},
            false)
        if (response && !response.internal) {
            setState({ open: true, severity: "success", message: "Answer updated successfully" })
        } else {
            setState({ open: true, severity: "error", message: "Failed to update answer" })
        }
    }
    return (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin', paddingBottom: '80px' }}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={state.open}
                onClose={handleClose}
                key={state.message}
                autoHideDuration={1000}
            >
                <Alert variant="filled" severity={state.severity}>
                    {state.message}
                </Alert>
            </Snackbar>
            <Dialog
                open={dialog.open}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {dialog.content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogContinue}>{dialog.button}</Button>
                    <Button onClick={handleDialogClose} autoFocus>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Stack>
                {reviewData && reviewData.QAList && reviewData.QAList.map((row, index) => (
                    <>
                        {row.Meta && row.MetaText !== "" && row.Question.Qtype === "passage" &&
                            <>

                                <Box display="flex" style={{ marginTop: '20px', marginLeft: '20px' }}>
                                    {index + 1}.
                                    &nbsp;&nbsp;
                                    <TextField
                                        label="Passage"
                                        defaultValue={row.Meta.MetaText}
                                        multiline
                                        id={row.Meta.ID}
                                        key={row.Meta.ID}
                                        fullWidth
                                    />
                                </Box>
                                <Box display="flex" style={{ marginTop: '20px', marginLeft: '20px' }}>
                                    &nbsp;&nbsp;
                                    &nbsp;&nbsp;
                                    <TextField
                                        label="Quesiton"
                                        defaultValue={row.Question.Qtext}
                                        multiline
                                        id={row.Question.ID}
                                        key={row.Question.ID}
                                        fullWidth
                                        onChange={(e) => {
                                            handleQuestionCange(index, e.target.value)
                                        }}
                                    />
                                    &nbsp;&nbsp;
                                    <AsyncButton type="submit" variant="contained" color="primary" onClick={async (e) => {
                                        e.preventDefault();
                                        await handleUpdateQuestion(index)
                                    }
                                    }>
                                        Update&nbsp;Question
                                    </AsyncButton>
                                </Box>
                            </>
                        }
                        {row.Meta === null &&
                            <Box display="flex" style={{ marginTop: '20px', marginLeft: '20px' }}>
                                {index + 1}.
                                &nbsp;&nbsp;
                                <TextField
                                    label="Quesiton"
                                    defaultValue={row.Question.Qtext}
                                    multiline
                                    id={row.Question.ID}
                                    key={row.Question.ID}
                                    fullWidth
                                    onChange={(e) => {
                                        handleQuestionCange(index, e.target.value)
                                    }}
                                />
                                &nbsp;&nbsp;
                                <AsyncButton type="submit" variant="contained" color="primary" onClick={async (e) => {
                                    e.preventDefault();
                                    await handleUpdateQuestion(index)
                                }
                                }>
                                    Update&nbsp;Question
                                </AsyncButton>
                            </Box>
                        }
                        {row.Options && row.Options.length > 0 && <Box style={{ marginTop: '20px', marginLeft: '20px' }}>
                            &nbsp;&nbsp;
                            &nbsp;&nbsp;
                            Options:
                        </Box>}
                        { row.Options && row.Options.map((option, oindex) => (
                            <>
                            
                            <Box display="flex" style={{ marginTop: '20px', marginLeft: '20px' }}>
                            &nbsp;&nbsp;
                            &nbsp;&nbsp;
                            &nbsp;&nbsp;
                            &nbsp;&nbsp;
                            <TextField
                                label={`Option ${oindex + 1}`}
                                value={option.Otext || ''}
                                multiline
                                id={option.ID}
                                key={option.ID}
                                fullWidth
                                onChange={(e) => {
                                    handleOptionChange(index, oindex, e.target.value)
                                }}
                            />
                            &nbsp;&nbsp;
                            <AsyncButton type="submit" variant="contained" color="success" onClick={async (e) => {
                                e.preventDefault();
                                await handleUpdateOption(index, oindex)
                            }}>
                                Update&nbsp;Option
                            </AsyncButton>
                        </Box>
                            </>
                            
                        ))}
                        <Box display="flex" style={{ marginTop: '20px', marginLeft: '20px' }}>
                            &nbsp;&nbsp;
                            &nbsp;&nbsp;
                            <TextField
                                label="Answer"
                                value={row.Answer.Atext || ''}
                                multiline
                                id={row.Answer.ID}
                                key={row.Answer.ID}
                                fullWidth
                                onChange={(e) => {
                                    handleAnswerChange(index, e.target.value)
                                }}
                            />
                            &nbsp;&nbsp;
                            <AsyncButton type="submit" variant="contained" color="success" onClick={async (e) => {
                                e.preventDefault();
                                await handleUpdateAnswer(index)
                            }}>
                                Update&nbsp;Answer
                            </AsyncButton>
                        </Box>
                        <Box display="flex" style={{ marginTop: '20px', marginLeft: '20px' }}>
                            &nbsp;&nbsp;
                            &nbsp;&nbsp;
                            <TextField
                                label="Hint"
                                value={row.Hint.Htext}
                                multiline
                                id={row.Hint.ID}
                                key={row.Hint.ID}
                                fullWidth
                            />
                            &nbsp;&nbsp;
                            <AsyncButton type="submit" variant="contained" color="warning" onClick={handleNext}>
                                Update&nbsp;Hint
                            </AsyncButton>
                        </Box>
                        <br></br>
                        <Divider sx={{ borderColor: "black" }}></Divider>
                        <br></br>
                    </>

                ))}

                <AsyncButton type="submit" variant="contained" color="primary" onClick={handleNext}>
                    Next
                </AsyncButton>
            </Stack>
        </Box>
    );
}

export default QAReview;